import { gql } from "@apollo/client";



export const LOGIN = gql`
query Login($loginData: AuthInput!) {
  login(loginData: $loginData) {
    token
    user {
      _id
      address {
        state
        country
        city
      }
      createdAt
      date_of_birth
      email
      fullName
      updatedAt
      phone
      userDetails {
        image
        organization {
          organizationName
          organizationId
        }
        profession
      }
      userType
    }
  }
}
`;

export const SINGLE_USER = gql`
query GetUserById($getUserByIdId: ID) {
  getUserById(id: $getUserByIdId) {
    _id
    address {
      city
      country
      state
    }
    createdAt
    date_of_birth
    email
    fullName
    phone
    updatedAt
    userDetails {
      image
      organization {
        organizationName
        organizationId
      }
      profession
    }
    userType
  }
}
`
export const ALL_USERS = gql`
query GetAllUsers($userType: UserTypeInput) {
  getAllUsers(UserType: $userType) {
    _id
    address {
      city
      country
      state
    }
    createdAt
    date_of_birth
    email
    fullName
    phone
    updatedAt
    userDetails {
      profession
      organization {
        organizationName
      }
    }
    userType
  }
}`
export const ALL_SURVEYORS = gql`
query GetAllUsers($userType: UserTypeInput) {
  getAllUsers(UserType: $userType) {
    _id   
    email
    fullName
    
  }
}`
export const GET_FORMS = gql`
query GetAllForms {
  getAllForms {
    adminDetails {
      fullName
      email
      phone
      _id
    }
    description
    formStatus
    formTitle
    formType
    surveyorDetails {
      fullName
      email
      phone
    }
    _id
    questions {
      questionTitle
      questionType
      id
      questionMetadata {
        max
        min
        choices
      }
      required
    }
    updatedAt
    createdAt
    
    formMetadata {
      theme {
        color
        font
        image
      }
      visibility
    }
    
  }
}`

export const GET_USER_FORM = gql`
query GetFormByIdQ($getFormByIdQId: ID) {
  getFormByIdQ(id: $getFormByIdQId) {
    _id
    description
    formMetadata {
      visibility
      theme {
        color
        font
        image
      }
    }
    formStatus
    formTitle
    formType
    questions {
      id
      questionMetadata {
        choices
        max
        min
      }
      questionTitle
      questionType
      required
    }
  }
} `

export const GET_FORM_BY_ID = gql`
query GetFormByIdA($getFormByIdAId: ID) {
  getFormByIdA(id: $getFormByIdAId) {
    adminDetails {
      createdAt
      date_of_birth
      email
      fullName
      phone
      updatedAt
      userDetails {
        profession
      }
      address {
        city
        country
        state
      }
      userType
      _id
    }
    formStatus
    formTitle
    description
    formMetadata {
      visibility
      theme {
        color
        font
        image
      }
    }
    formType
    questions {
      required
      questionType
      questionTitle
      questionMetadata {
        choices
        max
        min
      }
      id
    }
    responseDetails {
      responses {
        response {
          questionId
          responseText
        }
        userId
      }
      formId
    }
    surveyorDetails {
      userType
      userDetails {
        _id
        profession
        organization {
          organizationName
          organizationId
        }
        image
      }
      phone
      fullName
      email
      date_of_birth
      createdAt
      _id
    }
    updatedAt
    _id
    createdAt
  }
}`
export const GET_FORM_RESPONSES = gql`
query GetFormByIdA($getFormByIdAId: ID) {
  getFormByIdA(id: $getFormByIdAId) {
    _id
    responseDetails {
      responses {
        response {
          responseText
          questionId
        }
        userId
      }
    }
    formTitle
    questions {
      required
      questionType
      questionTitle
      id
      questionMetadata {
        min
        max
        choices
      }
    }
  }
} `

export const GET_SURVEYOR_FORMS = gql`
query GetRequestedForms {
  getRequestedForms {
    _id
    assignedAdmin
    createdAt
    formTitle
    description
    questions {
      questionMetadata
      questionTitle
      questionType
    }
    formType
    requestedSurveyor {
      phone
      fullName
      email
    }
    updatedAt
  }
}`

export const GET_FORM_RESPONSE_COUNT = gql`
query Query($getResCountByIdAId: ID) {
  getResCountByIdA(id: $getResCountByIdAId)
}`